export default __webpack_public_path__ + "static/media/facadePhotoImage.f79a20fc.png";